import { render } from "./TabIndex.vue?vue&type=template&id=5af4efaa&scoped=true"
import script from "./TabIndex.vue?vue&type=script&lang=js"
export * from "./TabIndex.vue?vue&type=script&lang=js"

import "./TabIndex.vue?vue&type=style&index=0&id=5af4efaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af4efaa"]])

export default __exports__